import { render, staticRenderFns } from "./ProductDocuments.vue?vue&type=template&id=f1391a2a&"
import script from "./ProductDocuments.vue?vue&type=script&lang=js&"
export * from "./ProductDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports